import { jsx } from "react/jsx-runtime";
import "react";
import { SnackbarProvider } from "notistack";
import { SnackbarContext, useSnackbarInternal } from "./useSnackbar.js";
function SnackbarProvider_SnackbarProvider(props) {
    const { children, ...notistackProps } = props;
    return /*#__PURE__*/ jsx(SnackbarProvider, {
        ...notistackProps,
        children: /*#__PURE__*/ jsx(SnackbarProviderInner, {
            children: children
        })
    });
}
function SnackbarProviderInner(props) {
    const context = useSnackbarInternal();
    return /*#__PURE__*/ jsx(SnackbarContext.Provider, {
        value: context,
        children: props.children
    });
}
export { SnackbarProvider_SnackbarProvider as SnackbarProvider };

//# sourceMappingURL=SnackbarProvider.js.map